/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import Vue from "vue";
/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
*
* Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
*/

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueTheMask from "vue-the-mask";
import VueGoodTable from "vue-good-table";

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

Vue.use(VueTheMask);
Vue.use(VueGoodTable);

Vue.component("register-form", () => import("./components/RegisterForm.vue"));
Vue.component("v-form-wizard", () => import("./components/step/form-wizard.vue"));
Vue.component("v-address-user", () => import("./components/AddreesComponent.vue"));
Vue.component("v-rules-boats", () => import("./components/RulesBoatsComponent.vue"));
Vue.component("v-lightbox-pagseguro", () => import("./components/LightboxPagseguroComponent.vue"));
Vue.component("v-repeat", () => import("./components/RepeatComponent.vue"));
Vue.component("app-measurement", () => import("./components/AppMeasurement.vue"));
Vue.component("app-admin", () => import("./components/admin/AppAdmin.vue"));
Vue.component("app-cupom", () => import("./components/AppCupom.vue"));
Vue.component("app-cupom-new", () => import("./components/AppCupomNew.vue"));
Vue.component("app-boats-annuities", () => import("./components/AppBoatsAnnuities.vue"));
Vue.component("app-boats-taxa-unica", () => import("./components/AppBoatsTaxaUnica.vue"));

// Register
Vue.component("v-boats-register", () => import("./components/BoatsComponent.vue"));
Vue.component("v-boats-register-new", () => import("./components/BoatsComponentNew.vue"));
// Shopping Cart
Vue.component("v-shopping-cart", () => import("./components/ShopppingCardComponent.vue"));

const app = new Vue({
    el: "#app",
    data(){
        return {
            form: {},
        };
    }
});
